import React       from 'react';
import QuoteTips   from 'pu-react/components/QuoteTips';
import PriceMatrix from './price/PriceMatrix'

import QuoteTipList from '../data/QuoteTips';

export default (props) => (
  <div className="pcb-price-section">
    <div className="price-matrices">
      <div className="price-matrix">
        <PriceMatrix {...props} />
      </div>
    </div>
    <div>
      <QuoteTips list={QuoteTipList} />
    </div>
  </div>
);
